import { FecAccountMappingStatus } from '../enums/fecAccountMappingStatus'
import { FecAccountMatchType } from '../enums/fecAccountMatchType'
import type { FecAccountMappingGroup, FecAccountMappingItem, FecAccountMappingsResponse } from '../query-api'
import type { FecAccountMapping } from '../types/fecAccountMapping'
import { getFecAccountMappingStatus } from './getFecAccountMappingStatus'

const getParentMatchType = (group: FecAccountMappingGroup): FecAccountMatchType => {
  const selfGroupedSubAccount = group.subAccounts.find(
    (subAccount) => subAccount.fecAccountNo === group.parentAccountNo,
  )

  return selfGroupedSubAccount?.matchType ?? FecAccountMatchType.Standard
}

const toItemRow = (item: FecAccountMappingItem, fecImportId: string): FecAccountMapping => ({
  accountNo: item.fecAccountNo,
  fecImportId,
  id: item.id,
  label: item.customLabel ?? item.fecLabel,
  matchType: item.matchType,
  status: FecAccountMappingStatus.New,
})

const toParentRow = (group: FecAccountMappingGroup, fecImportId: string): FecAccountMapping => {
  const matchType = getParentMatchType(group)

  return {
    accountNo: group.parentAccountNo,
    fecImportId,
    id: `parent:${fecImportId}:${group.parentAccountNo}`,
    label: group.parentLabel,
    matchType,
    status: getFecAccountMappingStatus(group.existsInBilly, matchType),
  }
}

export const flattenFecAccountMappings = (
  response: FecAccountMappingsResponse,
  fecImportId: string,
): FecAccountMapping[] => {
  const rows: FecAccountMapping[] = []

  for (const group of response.groups) {
    rows.push(toParentRow(group, fecImportId))

    for (const subAccount of group.subAccounts) {
      if (subAccount.fecAccountNo === group.parentAccountNo) {
        continue
      }

      rows.push(toItemRow(subAccount, fecImportId))
    }
  }

  for (const item of response.unknown) {
    rows.push(toItemRow(item, fecImportId))
  }

  return rows
}
